<template>
  <div class="container">
    <span @click="$emit('click')">
      <slot />
    </span>
  </div>
</template>

<script>
export default {
  name: 'VvBackButton'
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.container {
  margin-top: 5px;
  color: $font-color-light;
  text-decoration: underline;
  cursor: pointer;
}
</style>
